const userSettings = (
  state = { },
  action
) => {
  switch (action.type) {
    case 'UPDATE_USER_LOCATION':
    {
      const newState = Object.assign({}, state);
      newState['location'] = action.value;
      return newState;
    }

    default:
      return state
  }
}

export default userSettings



// WEBPACK FOOTER //
// ./src/infra/reducers/userSettings.js